import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { User } from '../../providers/user';
import { UserAccount } from '../../models/account';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Items } from '../../providers/providers';


/**
 * Generated class for the PaypalPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage({
	name: 'payment',
	segment: 'payment',
})
@Component({
	selector: 'page-payment',
	templateUrl: 'payment.html',
})

export class PaymentPage {
	//userData: UserData;
	chargebeeUrl:SafeResourceUrl;
  userAccountData: UserAccount;
  //payment: PayPalPayment = new PayPalPayment('10.10', 'USD', 'TV', 'sale');
  //currencies = ['AUD', 'USD']

  constructor(public navCtrl: NavController, public navParams: NavParams,public user: User,private domSanitizer: DomSanitizer,public items: Items,
	public viewCtrl: ViewController) {
	
  }

  ionViewDidLoad(){
	this.userAccountData = <UserAccount>JSON.parse(localStorage.getItem('accountData'));
    this.chargebeeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.userAccountData.chargebee_portal_url);
  }

  cancel() {
    this.viewCtrl.dismiss();
  }
  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    this.items.getAccountDetails().subscribe(res => {
          if (res) {
            this.userAccountData = res;
            localStorage.setItem('accountData', JSON.stringify(res));
            
          }
        }, err => {
          console.error('ERROR', err);
        });
    this.viewCtrl.dismiss();
  }

  makePayment() {

  }

//   makePayment() {
// 		this.payPal.init({
// 			PayPalEnvironmentProduction: '',
// 			PayPalEnvironmentSandbox: ''
// 		}).then(() => {
// 			this.payPal.prepareToRender('PayPalEnvironmentSandbox', new PayPalConfiguration({})).then(() => {
// 				this.payPal.renderSinglePaymentUI(this.payment).then((response) => {
// 					alert(`Successfully paid. Status = ${response.response.state}`);
// 					console.log(response);
// 				}, () => {
// 					console.error('Error or render dialog closed without being successful');
// 				});
// 			}, () => {
// 				console.error('Error in configuration');
// 			});
// 		}, () => {
// 			console.error('Error in initialization, maybe PayPal isn\'t supported or something else');
// 		});
// }
  

  

}



// WEBPACK FOOTER //
// ./src/pages/payment/payment.ts